<!--
 * @Author: RYL
 * @Description: 添加角色
 * @Date: 2020-12-24 17:22:03
 * @LastEditTime: 2020-12-25 18:11:18
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.Authoritymanagement.ANSI_PADDING')"
      :visible.sync="dialogVisible"
      width="30%"
      center>
      <!--      角色名称与角色描述-->
      <div style="text-align: center">
        <span class="tetxp">{{$t('lang.Authoritymanagement.Character')}}*</span>
        <el-input
          class="admininput"
          size="mini"
          v-model="adduser.role_name"
          :placeholder="$t('lang.Authoritymanagement.Executing')">
        </el-input>
      </div>
      <div style="text-align: center">
        <span class="tetxp">{{$t('lang.Authoritymanagement.Description')}}*</span>
        <el-input
          class="admininput"
          size="mini"
          v-model="adduser.role_description"
          :placeholder="$t('lang.Authoritymanagement.l_vinformupdate')">
        </el-input>
      </div>
      <el-tabs v-model="roleType">
        <el-tab-pane label="设备管理" name="device">
           <!--      权限树形列表-->
          <div style="height: 30vh;overflow-y: scroll;" v-loading="loading">
            <el-tree
              :data="TreeData"
              show-checkbox
              node-key="functionId"
              ref="AddTree"
              highlight-current
              render-after-expand
              :props="defaultProps">
            </el-tree>
          </div>
        </el-tab-pane>
        <el-tab-pane label="云监测" name="monitor" v-if="monState == 1">
           <!--      权限树形列表-->
          <div style="height: 30vh;overflow-y: scroll;" v-loading="loading">
            <el-tree
              :data="monitorList"
              show-checkbox
              node-key="functionId"
              ref="monitorTree"
              highlight-current
              render-after-expand
              :props="defaultProps">
            </el-tree>
          </div>
        </el-tab-pane>
      </el-tabs>
     
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.Authoritymanagement.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="addRoleuser">{{$t('lang.Authoritymanagement.Determine')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getFunctionalAuthority,
  showFunctionList,
  getRoleOwnFunction,
  modifyRoleFunction,
  deleteRole,
  addRole,
  modifyRoleNameAndDescription,
  queryKeyword
} from "@/api/Authoritymanagement";
import { GetMonitor } from '@/localStorage/localStorage'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      adduser: {
        role_name: "",
        role_description: "",
        functionList: []
      },
      TreeData: [],
      monitorList: [], // 云监测菜单
      //权限树形控件显示字段
      defaultProps: {
        children: 'functionList',
        label: 'functionName'
      },
      roleType: 'device',
      monState: 0, // 是否开通云监测功能
    }
  },
  methods: {
    clearData() {
      this.adduser = {
        role_name: "",
        role_description: "",
        functionList: []
      }
      this.TreeData = [],
      this.monitorList = [] // 云监测菜单
    },
    show() {
      this.clearData()
      this.monState = GetMonitor()
      // 获取设备管理最新权限列表
      showFunctionList(this.$i18n.locale == "en-US" ? 1 : 0, 0).then(res => {
        //获取树形菜单列表
        this.TreeData=res.data.queryResult
      })
      if(this.monState == 1) {
        // 获取云监测最新权限列表
        showFunctionList(this.$i18n.locale == "en-US" ? 1 : 0, 1).then(res => {
          //获取树形菜单列表
          this.monitorList=res.data.queryResult
        })
      }
      
      this.dialogVisible = true
    },
    //新增角色
    addRoleuser() {
      // 没有设置权限
      if (this.$refs.AddTree.getCheckedKeys() == 0 && this.$refs.monitorTree.getCheckedKeys() == 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.Authoritymanagement.Authorization"),
          type: "warning"
        });
        return;
      }
      let deviceRole = this.$refs.AddTree.getCheckedNodes(false,true).map(val=>val.functionId)
      let finalRole = []
      if(this.monState == 1) {
        let monitorRole = this.$refs.monitorTree.getCheckedNodes(false,true).map(val=>val.functionId)
        finalRole = deviceRole.concat(monitorRole)
      }else{
         finalRole = deviceRole
      }
      // 新增设备管理角色
      addRole(this.adduser.role_name,this.adduser.role_description, finalRole).then(res => {
        if (res.data.code === 0) {
           this.$message({
          message: this.$t("lang.Authoritymanagement.localSuccess"),
          type: "success"
        });
        } else {
          this.$message({
          message: this.$t("lang.Authoritymanagement.NewNextNotifyDT"),
          type: "warning"
        });
        }
      });
      // 新增云监测角色
      // await addRole(
      //   this.adduser.role_name,this.adduser.role_description,
      //   this.$refs.monitorTree.getCheckedNodes(false,true).map(val=>val.functionId), 1).then(res => {
      //   if (res.data.code === 0) {
      //     this.monitorFlag = true
      //   } else {
      //     this.monitorFlag = false
      //   }
      // });
      // if(deviceFlag && monitorFlag) {
      //   this.$message({
      //     message: this.$t("lang.Authoritymanagement.localSuccess"),
      //     type: "success"
      //   });
      // }else{
      //   this.$message({
      //     message: this.$t("lang.Authoritymanagement.NewNextNotifyDT"),
      //     type: "warning"
      //   });
      // }
      this.$emit('getFunctionalAuthority')
      this.dialogVisible = !this.dialogVisible;
    },
  }
}
</script>
<style scoped>
.tetxp {
  display: inline-block;
  width: 2.8rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}
</style>